import { useState } from "react";
import { Play } from "lucide-react";

interface YouTubeEmbedProps {
  videoId: string;
  title: string;
  posterUrl?: string;
  aspect?: string;
}

export function YouTubeEmbed({
  videoId,
  title,
  posterUrl,
  aspect = "16 / 9",
}: YouTubeEmbedProps) {
  const [loaded, setLoaded] = useState(false);
  const poster = posterUrl ?? `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;

  return (
    <div
      className="relative overflow-hidden rounded-md border border-border bg-muted"
      style={{ aspectRatio: aspect }}
    >
      {loaded ? (
        <iframe
          src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0`}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
          allowFullScreen
          className="absolute inset-0 h-full w-full"
        />
      ) : (
        <button
          type="button"
          onClick={() => setLoaded(true)}
          className="group absolute inset-0 flex h-full w-full flex-col items-center justify-center gap-4 p-6 text-center focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
          aria-label={`${title} laden`}
        >
          <img
            src={poster}
            alt=""
            className="absolute inset-0 h-full w-full object-cover opacity-75"
            loading="lazy"
            decoding="async"
          />
          <span className="absolute inset-0 bg-primary/75" aria-hidden="true" />
          <span className="relative flex h-16 w-16 items-center justify-center rounded-full bg-brand-button text-brand-button-foreground transition-transform group-hover:scale-105">
            <Play className="h-7 w-7 fill-current" strokeWidth={1.75} />
          </span>
          <span className="relative max-w-sm font-body text-sm leading-relaxed text-primary-foreground md:text-base">
            Video laden – dabei werden Daten an YouTube übertragen.
          </span>
        </button>
      )}
    </div>
  );
}
